var map = {
	"./act": 1585,
	"./act.ts": 1585,
	"./gmat": 1586,
	"./gmat.ts": 1586,
	"./gre": 1587,
	"./gre.ts": 1587,
	"./ielts": 1588,
	"./ielts.ts": 1588,
	"./ielts_general_training": 1589,
	"./ielts_general_training.ts": 1589,
	"./lsat": 1590,
	"./lsat.ts": 1590,
	"./mcat": 1591,
	"./mcat.ts": 1591,
	"./sat": 1592,
	"./sat.ts": 1592,
	"./toefl": 1593,
	"./toefl.ts": 1593
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 2641;
module.exports = webpackAsyncContext;